//@ts-check

import formatNumber from '@/core/filters/formatNumber';
import formatCurrency from '@/core/filters/formatCurrency';

const decimalFormat = ({ value }) => formatNumber(value ?? 0, {
  minimumFractionDigits: 2
});
const percentFormat = ({ value }) => formatNumber(value ?? 0, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}) + '%';
const numberFormat = ({ value }) => formatNumber(value ?? 0);
const currencyFormat = ({ value }) => formatCurrency(value ?? 0, 'en-US', 2);


/**
 * P
 */

/**
 * 
 * @type {Record<"errorsByPublisher" | "tableData",
 * (Partial<Omit<import('@ag-grid-community/core').ColDef, 'valueFormatter'>>
 *  & ({
 *      headerName: keyof typeof import('./locales').default.en
 *      field: (data.structures.RtbBreakdownByPublisherTableKeys | data.structures.RtbErrorTableKeys)
 *      valueFormatter?: (({value: any}) => any) | undefined
 *     })
 * )[]>}
 */
export const columnSettings = {
  errorsByPublisher: [
    {
      headerName: 'HEADER_PUBLISHER',
      field: 'affiliateName'
    },
    {
      headerName: 'HEADER_FINAL_CAPACITY_CHECK',
      field: 'zerortbbid:Final capacity check (Code: 1006)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_NO_CAPACITY',
      field: 'zerortbbid:No capacity (Code: 1003)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_3RD_PARTY_DATA_ENRICHMENT',
      field: 'zerortbbid:3rd Party Data Enrichment (Code: 1105)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_CALLER_ID',
      field: 'zerortbbid:Caller ID (Code: 1004)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_CALLER_ID_VERIFICATION',
      field: 'zerortbbid:Caller ID verification (Code: 1100)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_DISABLED',
      field: 'zerortbbid:Disabled (Code: 1001)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_INITIAL_TAG_FILTER',
      field: 'zerortbbid:Initial tag filter (Code: 1002)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_FINAL_TAG_FILTER',
      field: 'zerortbbid:Final tag filter (Code: 1005)',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
  ],
  tableData: [
    {
      headerName: 'HEADER_PUBLISHER',
      field: 'affiliateName'
    },
    {
      headerName: 'HEADER_PINGS',
      field: 'rtbbid',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_WINNING_BIDS',
      field: 'rtbwinningbid',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_REJECTED_BIDS',
      field: 'zerortbbid',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_RATE_LIMITED',
      field: 'rtbratelimit',
      valueFormatter: numberFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_AVG_BID',
      field: 'rtbbidavg',
      valueFormatter: currencyFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_AVG_WINNING_BID',
      field: 'rtbwinningbidavg',
      valueFormatter: currencyFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
    {
      headerName: 'HEADER_%_OF_WINNING',
      field: 'rtbwinningbidpercent',
      valueFormatter: percentFormat,
      cellClass: 'text-right',
      headerClass: 'text-right'
    },
  ]
};


export const tableData = columnSettings.tableData;
export const errorsByPublisher = columnSettings.errorsByPublisher;
